import { z } from 'zod'

export const repoTemplateInputSchema = z.object({
  sourceRepoId: z.string(),
  sourceTeam: z.object({
    id: z.string(),
    title: z.string(),
    slug: z.string(),
  }),
  linkOriginalCommits: z.boolean(),
  targetTeamId: z.string(),
  targetRepoName: z.string(),
  userId: z.string(),
  visibility: z.enum(['public', 'private']),
  gitRepoUrl: z.string().optional(),
  playgroundId: z.string().nullish(),
})

export type RepoTemplateInput = z.infer<typeof repoTemplateInputSchema>
